import React from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useAuth } from "@clerk/react";
import LoadingScreen from "../../components/LoadingScreen";

const GuestGuard = ({ children }) => {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return <LoadingScreen />;
  }
  if (isSignedIn) {
    return <Navigate to="/user/dashboard" replace />;
  }
  return <>{children}</>;
};

GuestGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GuestGuard;
